import { useState } from "react";
import { crearContrasena, validarNueva } from "./authService";
import PantallaEntrada, { Alerta, CampoContrasena } from "./PantallaEntrada";
import { guardarSesion } from "./session";

// Se abre desde el enlace del correo (invitación o nueva contraseña), que ya trae la sesión.
function CrearContrasena({ onListo }) {
  const [nueva, setNueva] = useState("");
  const [repetir, setRepetir] = useState("");
  const [error, setError] = useState("");
  const [guardando, setGuardando] = useState(false);

  const guardar = async (e) => {
    e?.preventDefault();
    const problema = validarNueva(nueva, repetir);
    if (problema) return setError(problema);
    setGuardando(true);
    setError("");
    try {
      const usuario = await crearContrasena(nueva);
      guardarSesion(usuario);
      onListo(usuario);
    } catch (e) {
      setError(e.message);
      setGuardando(false);
    }
  };

  return (
    <PantallaEntrada>
      <form onSubmit={guardar} className="panel w-full max-w-sm p-8" noValidate>
        <h2 className="mb-2 text-lg font-black uppercase tracking-tight text-white">Crea tu contraseña</h2>
        <p className="mb-5 text-sm text-gray-400">Con ella y tu correo entrarás de ahora en adelante.</p>
        <CampoContrasena id="nueva" etiqueta="Nueva contraseña" valor={nueva} onCambio={setNueva}
          autoComplete="new-password" deshabilitado={guardando} autoFocus />
        <CampoContrasena id="repetir" etiqueta="Repítela" valor={repetir} onCambio={setRepetir}
          autoComplete="new-password" deshabilitado={guardando} />
        {error && <Alerta>{error}</Alerta>}
        <button type="submit" disabled={guardando} className="btn-primario btn-lg w-full">
          {guardando ? "Guardando..." : "Guardar y entrar"}
        </button>
      </form>
    </PantallaEntrada>
  );
}

export default CrearContrasena;
